import { OutTopic } from '../out/OutTopic';
import { useServices } from 'app/hooks';

export function useSubscribers(topic: OutTopic) {
    const { embeddedApiService } = useServices();
    return embeddedApiService
        ? embeddedApiService
              .getSubscribersInfo()
              .filter((s) => topic === s.topic)
        : [];
}
